/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LeadReplacementsResponseApiModel } from '../../models/lead-replacements-response-api-model';

export interface GetPendingReplacements$Params {
}

export function getPendingReplacements(http: HttpClient, rootUrl: string, params?: GetPendingReplacements$Params, context?: HttpContext): Observable<StrictHttpResponse<LeadReplacementsResponseApiModel>> {
  const rb = new RequestBuilder(rootUrl, getPendingReplacements.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LeadReplacementsResponseApiModel>;
    })
  );
}

getPendingReplacements.PATH = '/admin/pending-replacements';
